module.exports = __webpack_public_path__ + "img/1477280443.08602969.jpg";